import { FormContainerComponent } from 'src/features/generalForms/builder/types/Container';

export const RootContainer: FormContainerComponent = ({ children }) => {
  return <div>{children}</div>;
};
